'use client'

import React, { useEffect } from 'react'
import { useSearchParams } from 'next/navigation'

const AdDensity: React.FC = () => {
  const params = useSearchParams()

  useEffect(() => {
    if (params.get('adDensity') === 'true') {
      const main = document.querySelector('main')
      if (!main) return
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })

      const timer = setTimeout(() => {
        const selectors = ['.ad-slot']

        const mainWidth = main.scrollWidth || main.clientWidth
        const mainHeight = main.scrollHeight || main.clientHeight
        const mainArea = mainWidth * mainHeight

        const ads = main.querySelectorAll(selectors.join(','))
        let adsArea = 0

        ads.forEach((ad) => {
          const rect = ad.getBoundingClientRect()

          const adWidth =
            (ad as HTMLElement).scrollWidth ||
            rect.width ||
            (ad as HTMLElement).offsetWidth
          const adHeight =
            (ad as HTMLElement).scrollHeight ||
            rect.height ||
            (ad as HTMLElement).offsetHeight

          if (adWidth > 0 && adHeight > 0) {
            adsArea += adWidth * adHeight
          }
        })

        if (mainArea > 0) {
          const adDensity = (adsArea / mainArea) * 100
          window.alert(
            `[Ad Density] ${adDensity.toFixed(2)}% ${adDensity > 30 ? '🔥' : '✅'}`,
          )
        }
      }, 10000)

      return () => clearTimeout(timer)
    }
  }, [])

  return null
}

export default AdDensity
